export default function validate(values) {
  const errors = {};
  if (!values.name) {
    errors.name = 'Please enter name';
  }
  if (!values.mpid) {
    errors.mpid = 'Please enter mpid';
  }
  if (!values.commission_percentage) {
    errors.commission_percentage = 'Please enter commission percentage';
  }
  if (!values.address) {
    errors.address = 'Please enter address';
  }
  if (!values.city) {
    errors.city = 'Please enter city';
  }
  if (!values.state) {
    errors.state = 'Please enter state';
  }
  if (!values.country) {
    errors.country = 'Please enter country';
  }
  
  if (!values.phone) {
    errors.phone = 'Please enter phone number';
  }
  if (!values.zipcode) {
    errors.zipcode = 'Please enter postal code';
  }
  if (!values.dtc) {
    errors.dtc = 'Please enter dtc';
  }
  return errors;
}
